import { OreNavBarUser, SvgLogout } from '@edenredespana/oreneta'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { WebTagPermissionEnum } from '@/Shared/domain'
import { loginSiteUrl } from '@/Shared/infrastructure/dynamicEndpoints'
import { useAuth } from '@/Shared/ui/auth'
import { useLoader } from '@/Shared/ui/loader'
import { NavbarUserListItem, useHeaderNavigationData } from '@/Shared/ui/navigation'
import {
  headerNavbarTranslation,
  navigationTranslation,
} from '@/Shared/ui/navigation/navigationTranslation'
import { useWebTagPermissions } from '@/User/context'
import { useUserData } from '@/User/ui/context'

export interface NavbarUserListItemModel {
  title: string
  icon?: JSX.Element
  link?: string
  handleClick?: () => void
  size?: 'text-sm' | 'text-xs'
  divider?: boolean
}

export const NavbarUser = (): JSX.Element => {
  const [openUser, setOpenUser] = useState(false)
  const { hasPermission } = useWebTagPermissions()
  const { startLoading, stopLoading } = useLoader()
  const { t } = useTranslation()
  const { navbarUserMenu } = useHeaderNavigationData()
  const { logOut } = useAuth()
  const { userName } = useUserData()

  const handleClickUser = (): void => setOpenUser(!openUser)

  const handleLogout = async (): Promise<void> => {
    startLoading()

    await logOut()
    window.location.href = loginSiteUrl

    stopLoading()
  }

  return (
    <OreNavBarUser
      userName={t(headerNavbarTranslation.myAccount)}
      userPlaceholderText={userName}
      open={openUser}
      handleClick={handleClickUser}
    >
      {navbarUserMenu.map((listItem: NavbarUserListItemModel, index: number) => {
        if (listItem.title === t(navigationTranslation.header.user.access)) {
          return hasPermission(WebTagPermissionEnum.VIEW_SHOW_WEB_ACCOUNTS_HANDLING) ? (
            <NavbarUserListItem
              key={index + 'access'}
              title={listItem.title}
              icon={listItem.icon}
              size={listItem.size}
              divider={listItem.divider}
              link={listItem.link}
              onClick={listItem.handleClick}
              parentClose={() => setOpenUser(false)}
            />
          ) : null
        }
        return (
          <NavbarUserListItem
            key={index + 'default'}
            title={listItem.title}
            icon={listItem.icon}
            size={listItem.size}
            divider={listItem.divider}
            link={listItem.link}
            onClick={listItem.handleClick}
            parentClose={() => setOpenUser(false)}
          />
        )
      })}
      <NavbarUserListItem
        title={navigationTranslation.header.user.logout}
        icon={<SvgLogout />}
        size="text-xs"
        divider={true}
        onClick={handleLogout}
        parentClose={() => setOpenUser(false)}
      />
    </OreNavBarUser>
  )
}
